/** @jsxImportSource @emotion/react */

import { ReactNode, memo } from "react";

import { SerializedStyles } from "@emotion/react";
import { Paper, Typography } from "@material-ui/core";

import { Button } from "..";
import { Props as ButtonProps } from "../Button";

import { container, content, header, titleContainer, body, btn, text, subtitleText, btnsContainer } from "./styles";

interface Action extends ButtonProps {
  label: string;
  primary?: boolean;
  actionDisabled?: boolean;
  disabledText?: string;
}

interface Props {
  children: ReactNode;
  title?: string;
  subtitle?: string | ReactNode;
  descriptionText?: string;
  adornmentIcon?: React.ReactChild;
  minWidth?: string;
  className?: string;
  actions?: Action[];
  bodyStyles?: SerializedStyles;
}

const Group = ({
  children,
  title,
  subtitle,
  descriptionText,
  adornmentIcon,
  minWidth,
  className,
  actions,
  bodyStyles,
}: Props): JSX.Element => {
  const renderActions = (): JSX.Element[] =>
    // @ts-expect-error
    actions.map(({ actionDisabled, disabledText, primary, color = "primary", label, ...rest }, i) =>
      actionDisabled ? (
        // eslint-disable-next-line react/no-array-index-key
        <div key={`text-${i}`} css={text}>
          {disabledText}
        </div>
      ) : (
        <Button
          // eslint-disable-next-line react/no-array-index-key
          key={`btn-${i}`}
          css={btn}
          variant={primary || color === "error" ? "contained" : "outlined"}
          color={color}
          {...rest}
        >
          {label}
        </Button>
      )
    );

  return (
    <Paper css={container} className={className} elevation={3}>
      <div css={content(minWidth)}>
        {title && (
          <div css={header}>
            <div>
              <div css={titleContainer}>
                <Typography variant="h6">{title}</Typography>
                {adornmentIcon}
              </div>
              {subtitle && <div css={subtitleText}>{subtitle}</div>}
            </div>
            {actions && <div css={btnsContainer}>{renderActions()}</div>}
            {descriptionText && <div css={text}>{descriptionText}</div>}
          </div>
        )}
        <div css={[body, bodyStyles]}>{children}</div>
      </div>
    </Paper>
  );
};

export default memo(Group);
